
import React from 'react';
import { Linkedin, Instagram } from 'lucide-react';
import { Link, useNavigate } from 'react-router-dom';
import { Separator } from "@/components/ui/separator";
import FAQ from '@/components/FAQ';

const Footer = () => {
  const navigate = useNavigate();
  const handleNavigation = (path: string) => {
    navigate(path);
    window.scrollTo(0, 0);
  };
  
  const scrollToFAQ = (e: React.MouseEvent) => {
    e.preventDefault();
    const faqSection = document.getElementById('faq-section');
    if (faqSection) {
      faqSection.scrollIntoView({
        behavior: 'smooth'
      });
    } else {
      // If we're not on a page with FAQ section, navigate to home and then scroll
      navigate('/#faq-section');
    }
  };
  
  return <footer className="bg-gradient-to-b from-white to-yellow-300/10 relative overflow-hidden">
      {/* FAQ Section */}
      <div id="faq-section" className="pb-8 pt-16">
        <FAQ />
      </div>
      
      <Separator className="bg-yellow-500/20 mx-auto max-w-6xl" />
      
      <div className="py-16 relative z-10">
        <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTUgMEwzMCAxMy4yMzJMMTUgMjYuNDY0SDE1TDAgMTMuMjMyTDE1IDBaTTQ1IDBMNS40NjQgMTMuMjMyTDQ1IDI2LjQ2NEg0NUw2MCAxMy4yMzJMNDUgMFpNMzAgMjYuNDY0TDQ1IDM5LjY5NkwzMCA1Mi45MjhIMzBMMTUgMzkuNjk2TDMwIDI2LjQ2NFpNMCA1My45MjhMMTUgNDAuNjk2TDAgMjcuNDY0SDBMLTEgNDAuNjk2TDAgNTMuOTI4Wk02MCAyNy40NjRMNzUgNDAuNjk2TDYwIDUzLjkyOEg2MEw0NSA0MC42OTZMNjAgMjcuNDY0Wk0xNSA4MC4zOTJMMzAgNjcuMTZMMTUgNTMuOTI4SDE1TDAgNjcuMTZMMTUgODAuMzkyWk00NSA4MC4zOTJMNjAgNjcuMTZMNDUgNTMuOTI4SDQ1TDMwIDY3LjE2TDQ1IDgwLjM5MloiIGZpbGw9IiNGRkQxMDAiIGZpbGwtb3BhY2l0eT0iMC4wNSIvPjwvc3ZnPg==')] opacity-25 z-0"></div>
        
        <div className="container mx-auto px-6 relative z-10">
          <div className="flex flex-col md:flex-row justify-between items-center gap-8 mb-12">
            {/* Logo and Company Info - Adjusted to a more moderate size */}
            <div className="flex items-center">
              <img alt="Snabbaupphandlingar - Effektiv analys av offentliga upphandlingar" className="h-14 md:h-16" src="/lovable-uploads/305d813d-2471-4640-8565-42092f775f53.png" />
            </div>
            
            {/* Social Links */}
            <div className="flex space-x-6">
              <a href="https://linkedin.com" className="h-10 w-10 rounded-full flex items-center justify-center bg-yellow-500/10 text-darkgray hover:bg-yellow-500 hover:text-white transition-colors duration-300" aria-label="LinkedIn" target="_blank" rel="noopener noreferrer">
                <Linkedin size={18} />
              </a>
              <a href="https://instagram.com" className="h-10 w-10 rounded-full flex items-center justify-center bg-yellow-500/10 text-darkgray hover:bg-yellow-500 hover:text-white transition-colors duration-300" aria-label="Instagram" target="_blank" rel="noopener noreferrer">
                <Instagram size={18} />
              </a>
            </div>
          </div>
          
          <Separator className="bg-yellow-500/20 my-8" />
          
          {/* Bottom Section with Copyright and Links */}
          <div className="flex flex-col md:flex-row items-center justify-between text-sm">
            <p className="text-darkgray/70 mb-4 md:mb-0 font-opensans">© 2025 Snabbaupphandlingar. All rights reserved.</p>
            <div className="flex flex-wrap gap-y-2 justify-center gap-x-8">
              <button onClick={scrollToFAQ} className="text-darkgray/80 hover:text-accent transition-colors font-montserrat font-medium">
                FAQ
              </button>
              <Link to="/integritetspolicy" className="text-darkgray/80 hover:text-accent transition-colors font-montserrat font-medium">
                Integritetspolicy
              </Link>
              <Link to="/villkor" className="text-darkgray/80 hover:text-accent transition-colors font-montserrat font-medium">
                Villkor
              </Link>
              <Link to="/cookies" className="text-darkgray/80 hover:text-accent transition-colors font-montserrat font-medium">
                Cookies
              </Link>
              <Link to="/gdpr" className="text-darkgray/80 hover:text-accent transition-colors font-montserrat font-medium">
                GDPR
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>;
};

export default Footer;
